import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { FormattedMessage } from 'react-intl';

import { Button, useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { giftCardRedemptionCtaMessages as messages } from './GiftCardRedemptionCta.messages';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardRedemptionCta = (props: GiftCardRedemptionCtaProps) => {
  const { redeemId } = props;

  const router = useRouter();
  const { currentBreakpoint } = useResponsive();
  const isInStoreOrdersEnabled = useFeatureFlag('CELS-4174-in-store-loyalty-orders-enabled'); // prettier-ignore

  // ─── Helpers ─────────────────────────────────────────────────────────

  const navigateToPaymentAndGiftCardScreen = useCallback(() => {
    if (currentBreakpoint.isXS) {
      router.navigate(`/redeem-gift-card/${redeemId}`);
      return;
    }

    if (isInStoreOrdersEnabled) {
      router.navigate(`/account/gift-cards/${redeemId}`);
      return;
    }

    router.navigate({ pathname: '/account/payment-and-gift-cards', params: { giftCardId: redeemId } }); // prettier-ignore
  }, [currentBreakpoint.isXS, isInStoreOrdersEnabled, router, redeemId]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Button size="large" onPress={navigateToPaymentAndGiftCardScreen}>
      <FormattedMessage {...messages.label} />
    </Button>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardRedemptionCtaProps = {
  redeemId: string;
};
